'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wasSentInAwayMode = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wasSentInAwayMode = exports.wasSentInAwayMode = (0, _getIn2.default)(_keyPaths.METADATA_SENT_IN_AWAY_MODE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/wasSentInAwayMode.js
// module id = 1089
// module chunks = 2 3